import { render, staticRenderFns } from "./FundCenter.vue?vue&type=template&id=22ce92e8&scoped=true"
import script from "./FundCenter.vue?vue&type=script&lang=js"
export * from "./FundCenter.vue?vue&type=script&lang=js"
import style0 from "./FundCenter.vue?vue&type=style&index=0&id=22ce92e8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ce92e8",
  null
  
)

export default component.exports